import {createStore, applyMiddleware} from 'redux'
import rootReducer from '../reducers'
import {createLogger} from 'redux-logger'
import thunk from 'redux-thunk'
import createHistory from 'history/createHashHistory'
import {routerMiddleware} from 'react-router-redux'


export default function configureStore(initialState) {
    const logger = createLogger()
    const history = createHistory();
    const rtMiddleware = routerMiddleware(history);
    const store = createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk, logger, rtMiddleware))

        if (module.hot) {
            module.hot.accept('../reducers', () => {
                const nextRootReducer = require('../reducers')
                store.replaceReducer(nextRootReducer)
            })
        }

    return {store, history}
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js